export default __webpack_public_path__ + "36dddf34bbac00e5d539ac75ce39df05.ttf";